import { fetchMemberTimeline } from '@/api/fetchMemberTimeline'
import { QUERY_KEY } from '@/constants/queryKey'
import { useInfiniteScroller } from '@/hooks/livemallclub/useInfiniteScroller'
import { MerchantProductInfo } from '@/types/merchant-product-list'

export type MemberTimelineProductFeedType = {
  type: 'product'
  productMeta: MerchantProductInfo
}

export type MemberTimelineProductResponseType = {
  cursorId: string
  feeds: MemberTimelineProductFeedType[] | null
  hasMore: boolean
}[]

const useMemberProductsQuery = ({ memberInfoId, enabled = true }: { memberInfoId: string; enabled?: boolean }) => {
  const props = useInfiniteScroller<MemberTimelineProductResponseType>({
    queryKey: [QUERY_KEY.FETCH_MEMBER_TIMELINE_PRODUCTS, { pageSize: 5, type: 'product', memberInfoId }],
    queryFunction: ({ pageParam }) =>
      fetchMemberTimeline({
        type: 'product',
        pageSize: 5,
        memberInfoId,
        cursorId: pageParam?.cursorId,
      }),
    queryOptions: {
      enabled: !!memberInfoId && !!enabled,
    },
  })

  return {
    ...props,
  }
}

export default useMemberProductsQuery
